import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import styles from "./ThreatsDashboardPanels.module.css";
import InfoBoxRedirectButton from "app/common/InfoBoxRedirectButton";

const asNumber = (value) => Number(value) || 0;
const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const ZeroDayVulnerabilitiesPanel = ({
  riskIndicators = {},
  exploitStatus = [],
  record,
}) => {
  const navigate = useNavigate();
  const counts = useMemo(
    () =>
      exploitStatus.reduce((result, item) => {
        result[normalize(item.label)] = asNumber(item.value);
        return result;
      }, {}),
    [exploitStatus],
  );
  const zeroDayCount =
    asNumber(riskIndicators.zeroDayCount) ||
    Object.values(counts).reduce((sum, value) => sum + value, 0);
  const statusCards = [
    { label: "Zero-day threats", value: zeroDayCount, tone: "pink" },
    {
      label: "Active",
      value: counts.active ?? asNumber(riskIndicators.activelyExploitedCount),
      tone: "danger",
    },
    { label: "Proof of concept", value: counts.poc ?? 0, tone: "warning" },
    {
      label: "Not available",
      value: counts["not available"] ?? 0,
      tone: "neutral",
    },
  ];

  return (
    <InfoBox
      header="Zero-day Vulnerabilities"
      subtitle="Exploit status of detected zero-day threats"
      badge={
        <InfoBoxRedirectButton
          type="button"
          className={styles.viewAll}
          onClick={() => navigate("/app/secure/threats/zero-day/summary")}
        />
      }
      badgeProps={{ className: styles.viewAllBadge }}
      className={styles.panel}
      childrenProps={{ className: styles.zeroDayContent }}
    >
      <div className={styles.zeroDayStats}>
        {statusCards.map((stat) => (
          <div key={stat.label} className={styles.zeroDayStat}>
            <strong className={styles[stat.tone]}>
              {stat.value.toLocaleString()}
            </strong>
            <span>{stat.label}</span>
          </div>
        ))}
      </div>
      {record ? (
        <div className={styles.zeroDayFeature}>
          <strong>{record.cveId}</strong>
          <span className={styles.severityBadge}>
            {record.severity || "Not rated"}
          </span>
          <p>
            {record.vulnerableSoftware || "Affected software"} | CVSS{" "}
            {record.cvssScore ?? "--"} | Exploit score{" "}
            {record.exploitScore ?? "--"} | {asNumber(record.deviceCount)}{" "}
            affected systems
          </p>
        </div>
      ) : (
        <div className={styles.emptyState}>
          No zero-day vulnerability details available.
        </div>
      )}
    </InfoBox>
  );
};

export default ZeroDayVulnerabilitiesPanel;
